export default "__VITE_PUBLIC_ASSET__737cf916__"